import { IMAGES, WEB_COLORS } from "@/lib/constants";
import { Stack, Typography } from "@mui/material";
import Image from "next/image";

export default function InfoTile({ text, sx, containerSx }) {
  return (
    <Stack
      direction={"row"}
      alignItems="center"
      spacing={0.5}
      margin={"5px 0px"}
      sx={containerSx}>
      <Image
        src={IMAGES.infoGreen}
        style={{
          transform: "scale(0.8)",
        }}
        alt="Info Icon"
      />
      <Typography
        sx={{
          fontSize: { xs: "12px", md: "14px" },
          fontWeight: 400,
          ...sx,
        }}
        color={WEB_COLORS.primary}
        gutterBottom={1}>
        {text}
      </Typography>
    </Stack>
  );
}
